export const typicalWaitTimeFormatter = (
  waittime?: number,
  shortLabel: boolean = false
): string => {
  if (!waittime) {
    return 'Not available';
  }
  const minutes = Math.trunc(waittime / 60);
  const hours = Math.trunc(minutes / 60);

  if (minutes < 2) {
    return shortLabel ? '< 2min' : '< 2 minutes';
  } else if (hours < 1) {
    return shortLabel ? `${minutes}min` : `${minutes} minutes`;
  } else if (hours === 1) {
    return shortLabel ? '1h' : '1 hour';
  } else {
    return shortLabel ? `${hours}h` : `${hours} hours`;
  }
};
